export default __webpack_public_path__ + "static/media/multi-device-Q2.135b0add.png";